/**
 * Global state for the MSAL migration modal.
 *
 * This Zustand store manages visibility of the modal that appears when users
 * with stale MSAL sessions attempt to use the app with Supabase-only auth.
 *
 * Callable from anywhere, including outside React (e.g., HTTP interceptor module).
 */

import { create } from "zustand";

interface MsalMigrationModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useMsalMigrationModal = create<MsalMigrationModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
